var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 25,
    viewBox: "0 0 33 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5337 6.28563C29.5536 6.55156 29.5536 6.81749 29.5536 7.08588C29.5536 15.2636 22.7939 24.6949 10.4336 24.6949V24.69C6.78229 24.6949 3.20685 23.7317 0.133057 21.9155C0.663984 21.9744 1.19757 22.0038 1.73249 22.005C4.75838 22.0074 7.69777 21.0724 10.0783 19.3506C7.20277 19.3003 4.6812 17.5736 3.80031 15.0528C4.80761 15.2317 5.84552 15.1949 6.83419 14.9462C3.69919 14.3628 1.44374 11.8261 1.44374 8.87999C1.44374 8.85303 1.44374 8.8273 1.44374 8.80156C2.37786 9.28073 3.42374 9.54666 4.49358 9.57607C1.54088 7.75867 0.630718 4.14102 2.41378 1.31259C5.82556 5.17901 10.8594 7.5295 16.2631 7.77828C15.7216 5.62877 16.4614 3.37632 18.2072 1.86529C20.9137 -0.477849 25.1705 -0.357751 27.7147 2.13367C29.2196 1.86039 30.6621 1.35181 31.9821 0.631219C31.4804 2.06382 30.4305 3.28073 29.028 4.05401C30.36 3.90941 31.6614 3.58097 32.8869 3.07975C31.9847 4.32485 30.8483 5.40941 29.5337 6.28563Z",
    fill: "#838383",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterGrey);
export default __webpack_public_path__ + "static/media/TwitterGrey.f19fff38372c9cb5a8524bee53981b7d.svg";
export { ForwardRef as ReactComponent };